var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.625V2.17188C9.99609 2.58203 11.5 4.33203 11.5 6.4375V6.95703C11.5 8.24219 11.9648 9.5 12.8125 10.457L13.0039 10.6758C13.25 10.9492 13.3047 11.3047 13.168 11.6328C13.0312 11.9336 12.7031 12.125 12.375 12.125H1.875C1.51953 12.125 1.19141 11.9336 1.05469 11.6328C0.917969 11.3047 0.972656 10.9492 1.21875 10.6758L1.41016 10.457C2.25781 9.5 2.75 8.24219 2.75 6.95703V6.4375C2.75 4.33203 4.22656 2.58203 6.25 2.17188V1.625C6.25 1.16016 6.63281 0.75 7.125 0.75C7.58984 0.75 8 1.16016 8 1.625ZM7.125 14.75C6.66016 14.75 6.19531 14.5859 5.86719 14.2578C5.53906 13.9297 5.375 13.4648 5.375 13H8.875C8.875 13.4648 8.68359 13.9297 8.35547 14.2578C8.02734 14.5859 7.5625 14.75 7.125 14.75Z",
    fill: "#AAB0B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8b93b2de.svg";
export { ForwardRef as ReactComponent };